export default __webpack_public_path__ + "static/media/logouticon.f95c5371.svg";